// extracted by mini-css-extract-plugin
export var equalColumn = "_jr-0";